import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { PipeModule } from '../pipe/pipe.module';
import { QuillModule } from 'ngx-quill';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { NavigationModule } from './header-navigation/navigation.module';
import { AlertModule } from './alert/alert.module';
import { PreloaderModule } from './preloader/preloader.module';


import { ToolbarModule } from './toolbar/toolbar.module';
import { SelectProgramJobsiteModule } from './select-program-in-jobsite/select-program-in-jobsite.module';
import { PublicCsatFeedbackModule } from './public-csat-feedback/public-csat-feedback.module';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        PipeModule,
        NgSelectModule,
        QuillModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NavigationModule,
        AlertModule,
        PreloaderModule,
        ToolbarModule,
        SelectProgramJobsiteModule,
        PublicCsatFeedbackModule,
        ConfirmDialogModule
    ],
    exports: [
        NavigationModule,
        AlertModule,
        PreloaderModule,
        ToolbarModule,
        ConfirmDialogModule
    ]
})

export class SharedModule { }
